import {
  ChangeDetectionStrategy,
  Component,
  computed,
  HostBinding,
  input,
  ViewEncapsulation,
} from '@angular/core';

import { IconFamily } from './models/icon-family.type';
import { DgxIconName } from './models/icon-name.type';
import { IconSize } from './models/icon-size.type';
import { Icon } from './models/icon.type';
import { loadFontAwesomeScript } from './utils/icon/icon.utils';

@Component({
  selector: 'app-icon',
  template: ``,
  styleUrl: './icon.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class IconComponent {
  family = input<IconFamily>('light');
  icon = input<Icon | undefined>(undefined);
  name = input<DgxIconName | string | undefined>(undefined);
  size = input<IconSize | undefined>(undefined);

  @HostBinding('attr.aria-hidden') ariaHidden = 'true';
  @HostBinding('attr.role') role = 'img';

  readonly iconName = computed(() => {
    const icon = this.icon();
    if (typeof icon === 'string') return icon;
    if (icon && 'name' in icon) return icon.name;
    return this.name();
  });

  @HostBinding('class')
  get class(): string {
    const family = this.family() ?? 'light';
    const name = this.iconName();
    const size = this.size() ?? 'md';
    const classes = [`icon--${size}`];

    if (name) {
      classes.push(`fa-${family}`, `fa-${name}`);
    }

    return classes.join(' ');
  }

  constructor() {
    loadFontAwesomeScript();
  }
}
